import AssessmentIcon from "@mui/icons-material/Assessment";
import CollectionSummaryPage from "./CollectionSummaryPage";

export default {
  list: CollectionSummaryPage,
  icon: AssessmentIcon,
  label: "Collection summary",
  options: { label: "Collection summary" },
  name: "feeCollectionSummary",
};
